import { useAppDispatch } from 'app/hooks';
import { ChangeEvent, forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Form, Modal, ModalProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { csvToJSON } from 'utils/csvToArrayJson';
import { menuListActions } from '../menuSlice';
import { MenuCsv } from '../models/menu';
import CSVDownloader from './ExportCSVTemplate';

const ImportCSVModal = forwardRef<ModalProps, {}>((props, ref) => {
  const [showModal, setShowModal] = useState(false);
  const [fileImport, setFileImport] = useState<File>();
  const [dataCsvImport, setDataCsvImport] = useState<Array<{}>>([]);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  useImperativeHandle(ref, () => ({
    closeModal() {
      setShowModal(false);
      setFileImport(undefined);
      setDataCsvImport([]);
    },
    openModal() {
      setShowModal(true);
    },
  }));

  // effect
  useEffect(() => {
    readMenuCSV();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileImport]);

  const handleOnChangeFileImport = (e: ChangeEvent<HTMLInputElement>) => {
    // Check if user has entered the file
    if (e.target.files && e.target.files.length) {
      const inputFile = e.target.files[0];
      const fileExtension = inputFile?.type.split('/')[1];
      if (fileExtension !== 'csv') {
        return;
      }
      // If input type is correct set the state
      setFileImport(inputFile);
    }
  };

  const readMenuCSV = () => {
    if (!fileImport) return;
    const reader = new FileReader();
    reader.onload = function (event) {
      const text = event?.target?.result as string;
      const data = csvToJSON(text);
      setDataCsvImport(data);
    };
    reader.readAsText(fileImport);
  };

  const handleImportCsv = () => {
    if (dataCsvImport.length > 0) {
      const data = dataCsvImport as MenuCsv[];
      dispatch(menuListActions.postMenu(data));
      setShowModal(false);
    }
  };

  return (
    <>
      <div className="static-modal">
        <Modal animation={false} centered={true} show={showModal} backdrop={'static'} keyboard={false}>
          <Modal.Header>
            <Modal.Title className="text-warning">{t('MenuList.ModalImportCsv.title')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>{t('MenuList.ModalImportCsv.label')}</Form.Label>
              <Form.Control type="file" accept=".csv" onChange={handleOnChangeFileImport} />
            </Form.Group>
            <Form.Group controlId="formFile" className="mb-3">
              <CSVDownloader />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="d-flex">
            <button
              className="btn btn--red ms-auto"
              onClick={() => {
                setShowModal(false);
              }}
            >
              {t('MenuList.ModalImportCsv.btn_cancel')}
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button className="button-l btn-primary" onClick={handleImportCsv}>
              {t('MenuList.ModalImportCsv.btn_save')}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
});

export default ImportCSVModal;
